exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".automation-execution-switch .ant-switch-checked {\n  background-color: #085FCE !important;\n}", ""]);

// exports
